<div class="explore-destinations">
	<div class="container">
		<!-- *** Explore all the destinations *** -->
		<section class="grid position-relative">
		
			<div class="explore-destinations__background-image">
				<app-svg class="explore-destinations__world-map" svg="sprite.svg#misc--world" [alt]="'World map image'" aria-hidden="true"></app-svg>
			</div>

			<div class="col-4 col-tp-12 col-p-12 explore-destinations__content">

				<h4 class="explore-destinations__content__title">
					TAP flies to<br>
					<span>{{totalDestinations}}  destinations</span><br>
					around the world<br>
				</h4>

				<p class="explore-destinations__content__text">Explore all the destinations you can fly to with TAP and its partner airlines</p>
			</div>

			<div class="col-8 col-tp-12 col-p-12 explore-destinations__plane">
				<img [attr.src]="url" alt="TAP Air Portugal airplane image" aria-hidden="true">
			</div>

		</section>
	</div>

	<div  class="container explore-destinations__destinations">
		<app-large-input-select
			*ngIf="isScreenMobileTabletPortrait"
			class="col-p-12"
			[(ngModel)]="selected_destinations"
			[inputOptions]="destinations"
			[inputValue]="selected_destinations"
			[id]="'flight-explore-destinations'"
			[label]="'Destination'"
			[placeholderLabel]="'Select destination'" >
		</app-large-input-select>

		<app-segmented-control-radio *ngIf="!isScreenMobileTabletPortrait" classes="segmented-control--rounded" (selected)="INDRA_setPutDestination($event)" [_value]="selected_destinations" [options]="destinations">
		</app-segmented-control-radio>

		<section class="block-destinations" *ngIf="destinations && !loading">

			<div class="block-destinations__country" *ngFor="let country of airportsPerCountry">
				<a class="title-country" href="javascript:;" role="button">{{country.label}}</a>
				<ul>
					<li *ngFor="let place of country.places">
						<a class="link" href="javascript:;" role="button">{{ place.label }}</a>
					</li>
				</ul>
			</div>

		</section>
		<app-loading *ngIf="loading"></app-loading>

	</div>
</div>
